import { render, staticRenderFns } from "./Pop-up.vue?vue&type=template&id=23653808&"
import script from "./Pop-up.vue?vue&type=script&lang=js&"
export * from "./Pop-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports